//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SwitchType from './switchType';
import mgDialog from '~/components/custom/mg-dialog.vue';
import { getSubs, getRecord, addRecord } from '@/api/subs';

import {
  expiredMillisecond,
  resourceMaxMillisecond,
  activityMaxMillisecond,
  pluginMaxMillisecond,
  resourceMaxAccessNum,
  activityMaxAccessNum,
  pluginMaxAccessNum,
  clearRecordNum,
} from './subscription.js';
import { isMobile } from '~/utils/constants';

const SUBS = {
  hasSubs: false, 
  expired: 0,
  accessNum: 0,
  isUserBehavior: false,
  createTime: 0, 
}

export default {
  components: {
    SwitchType,
    mgDialog,
  },
  data() {
    return {
      isShow: false,
      title: '',
      curIcon: '',
      switchTitle : '',
      switchDesc: '',
    }    
  },
  props: {
    pageType: {
      type: String, /* resource 资源广场  activity 每周临摹  plugin 插件广场 */
      default: ''
    }
  },
  computed: {
    colorMode() {
      return this.$store.state.user.colorMode || 'light';
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    isShowSubScribe() {
      return this.$store.state.user.isShowSubScribe; 
    },
    maxAccessNum() {
      const type = this.pageType;
      if(type === 'resource') return resourceMaxAccessNum;
      if(type === 'activity') return activityMaxAccessNum;
      if(type === 'plugin') return pluginMaxAccessNum;
      return resourceMaxAccessNum;
    },
    maxMillisecond() {
      const type = this.pageType;
      if(type === 'resource') return resourceMaxMillisecond;
      if(type === 'activity') return activityMaxMillisecond;
      if(type === 'plugin') return pluginMaxMillisecond;
      return resourceMaxMillisecond;
    }
  },
  watch: {
    isShowSubScribe(flag) {
      if (flag && this.isExpired()) {
        this.isShow = true;
      }
      this.$store.dispatch('user/setSubScribe', false);
    },
    isShow(show) {
      if (show) {
        if (isMobile()) {
          this.isShow = false;
          return;
        }
        this.showDialogReport();
      }
    }
  },
  mounted() {
    this.open();
    this.initDialog();
  },
  methods: {
    async showDialogReport() {
      clearRecordNum();
      if (this.userInfo.id) {
        await addRecord();
      } else {
        const type = this.pageType.toUpperCase();
        const key = `MG_SUBS_${type}`;
        this.initSubsClose(key);
        SUBS.expired = Date.now() + expiredMillisecond; 
        window.localStorage.setItem(key, JSON.stringify(SUBS));
      }
    },
    getLocalTime(nS) {     
      return new Date(nS).toLocaleString().replace(/:\d{1,2,3}$/,' ');     
    },
    open() {
      if (this.userInfo.id) {
        this.userDialogRule(); 
      } else {
        this.anonymousUserDialogRule();
      }
    },
    async userDialogRule() {
      try {
        const key = `MG_SUBS_${this.pageType.toUpperCase()}`;
        const subs = JSON.parse(window.localStorage.getItem(key));
        if (!subs) return;

        if (subs.accessNum !== this.maxAccessNum) {
          return;
        }

        if (subs.isUserBehavior) {
          subs.isUserBehavior = false;
          return;
        }
        const resSubs = await getSubs();
        if (resSubs.code === 'OK' && resSubs.data.hasSub) {
          this.isShow = false;
          return;
        }
        const resRecord = await getRecord();
        if (resRecord.code === 'OK' && !resRecord.data.recentlyPop) {
          this.isShow = true;
        }
      } catch (error) {
        console.error(error);
      }
    }, 
    anonymousUserDialogRule() {
      try {
        const key = `MG_SUBS_${this.pageType.toUpperCase()}`;
        const subs = JSON.parse(window.localStorage.getItem(key));
        if (!subs || subs.hasSub || !this.isExpired()) {
          return;
        }

        if (subs && subs.isUserBehavior) {
          subs.isUserBehavior = false;
          return;
        }
        if (subs.accessNum === this.maxAccessNum) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    isExpired() {
      try {
        if (this.userInfo.id) {
          return true;
        }
        const nowTime = Date.now();
        return ['RESOURCE', 'PLUGIN', 'ACTIVITY'].every(str => {
          const key = `MG_SUBS_${str}`;
          const data = window.localStorage.getItem(key);
          if (!data) return true;
          const subs = JSON.parse(data);
          if (!subs) return true;
          return !subs.hasSubs && (nowTime - subs.expired - expiredMillisecond >= 0);
        })
      } catch (error) {
        return true;
      }
    },
    isWithinMaxMillisecond () {
      const key = `MG_SUBS_${this.pageType.toUpperCase()}`;
      const subs = JSON.parse(window.localStorage.getItem(key));
      if (!subs || subs.hasSubs || subs.createTime === 0) {
        return false;
      }

      if (Date.now() < (subs.createTime + this.maxMillisecond)) {
        return true;
      }
      return false;
    },
    initDialog() {
      switch(this.pageType) {
        case 'resource':
          this.title = '订阅 MasterGo 资源广场';
          this.curIcon = require("@/assets/subscribe/resource.png");
          this.switchTitle = '未找到想要的资源吗？';
          this.switchDesc = '订阅 MasterGo 资源广场，我们将每周向您推荐 最新最热的资源与信息。';
          break;
        case 'activity':
          this.title = '订阅 MasterGo 活动广场';
          this.curIcon = require("@/assets/subscribe/activity.png");
          this.switchTitle = '未找到想要的活动吗？';
          this.switchDesc = '订阅 MasterGo 活动广场，我们将每周向您推荐 最新最热的活动与信息。';
          break;
        case 'plugin':
          this.title = '订阅 MasterGo 插件广场';
          this.curIcon = require("@/assets/subscribe/plugin.png");
          this.switchTitle = '未找到想要的插件吗？';
          this.switchDesc = '订阅 MasterGo 插件广场，我们将每周向您推荐 最新最热的插件与信息。';
          break;
        default:
          break;
      }
    },
    initSubsClose(key) {
      SUBS.createTime = 0; 
      SUBS.accessNum = 0; 
      SUBS.expired = 0;
      window.localStorage.setItem(key, JSON.stringify(SUBS));
    },
    handleClose() {
      this.isShow = false;
    },
    addAccessNum() {
      if (isMobile()) return;
      const key = `MG_SUBS_${this.pageType.toUpperCase()}`;
      try {
        const subsData = JSON.parse(window.localStorage.getItem(key));
        if (subsData) {
          if (!this.isExpired()) {
            return;
          }

          if (!this.isWithinMaxMillisecond()) {
            subsData.accessNum = 1;
            subsData.createTime = Date.now();
            window.localStorage.setItem(key, JSON.stringify(subsData));
            return;
          }

          if (subsData.accessNum >= this.maxAccessNum) {
            subsData.accessNum = 0;
            subsData.createTime = 0;
            subsData.isUserBehavior = false;
            subsData.expired = 0;
          }
          if (subsData.createTime === 0) {
            subsData.createTime = Date.now();
          }
          subsData.accessNum++;
          window.localStorage.setItem(key, JSON.stringify(subsData));
        } else {
          SUBS.accessNum = 1;
          SUBS.createTime = Date.now();
          SUBS.expired = 0;
          SUBS.isUserBehavior = false;
          window.localStorage.setItem(key, JSON.stringify(SUBS));
        }
        if (this.pageType === 'activity') return;
        this.open();
      } catch (error) {
        console.error(error);
      }
    },
    handleSubs() {
      try {
        this.isShow = false;
        const type = this.pageType.toUpperCase();
        const key = `MG_SUBS_${type}`;
        const subs = JSON.parse(window.localStorage.getItem(key));
        if (!subs) {
          SUBS.hasSubs = true;
          window.localStorage.setItem(key, JSON.stringify(SUBS));
        }
        subs.hasSubs = true;
        window.localStorage.setItem(key, JSON.stringify(subs));
      } catch (error) {
        console.error(error);
      }
    }
  }
};
